import { createFileRoute } from '@tanstack/react-router'

import { Integrations } from '@/widgets/integrations'

export const Route = createFileRoute('/_app/settings/integrations')({
  component: RouteComponent,
})

export const IntegrationsRoute = Route

function RouteComponent() {
  return <Integrations />
}
